// Improvements for the future, making individual email's to, cc, and bcc editable
// Rewrite nesting ternary

import React, { useEffect } from 'react'
import { toJS } from 'mobx'
import _ from 'lodash'
import { Scrollbars as CustomScrollBars } from 'react-custom-scrollbars'
import { showDialog } from '@components/Dialog'
import RichTextEditor from '@components/RichTextEditor'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  LinearProgress,
  Switch,
  TextField,
  Chip,
  Tooltip as TooltipMUI
} from '@material-ui/core'

import Autocomplete, {
  createFilterOptions
} from '@material-ui/lab/Autocomplete'
import {
  actions
} from '../../listView.reducer'
import { ListViewDispatchContext, ListViewStateContext } from '../../listView.context'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import flat from 'flat'
import {
  validators,
  validate,
  getScheduledTime,
  getTemplateType,
  getGlobalTemplateType
} from './helper'
import getAdditionalEmployee from '../../api/getAdditionalEmployee'
import getSupervisor from '../../api/getSupervisor'
import { stores } from '../../../stores'
import getAdditionalReplacements from '../utils/replacements'
import { masterTemplateStatic } from '../../../../../api/emailTemplate/helpers/masterTemplate.static'

import { emailTemplateApi, massProcessingApi } from '@atheneum/api'
import Tooltip from 'frontend/src/components/Tooltip/Tooltip'

// Have this as a function because if we have it as a plain object, it will only get the values from localStorage once when it loads.
// This creates a problem, if an user logout and login without refreshing, it will get the old values in the global variable
export const getInitialState = () => {
  const replacements = getAdditionalReplacements()
  const localStorageUser = JSON.parse(localStorage.getItem('ngStorage-user'))
  const { templateTypes } = masterTemplateStatic

  const repeatedValueForTabs = {
    /**
     * @type {{ subject: string; content: string; }}
     */
    selectedTemplate: {},
    selectedTemplateIndex: 0,
    // The templates choices
    templates: [],
    from: localStorageUser,
    bcc: [],
    cc: [],
    subject: 'Atheneum Partners',
    templateTypes
  }

  return {
    finishAction: SendEmails,
    // Values for display starts
    loading: false,
    template: '',
    templateTypes,
    selectedTemplateType: getGlobalTemplateType(),
    to: {},
    cc: [],
    bcc: [],
    showTemplate: true,
    minuteError: false,
    supervisor: null,
    // For preview, to indicate the current index of items(which is the array of experts)
    currentItem: 0,
    sendingEmails: false,
    automationFrequencyInMinutes: 360,
    isAutomatedFollowup: false,
    // Extra variables for templates
    additionalReplacements: replacements,
    // Only used if isAutomatedFollowup is true
    selectedTabIndex: 0,
    previewTabs: [
      {
        ...repeatedValueForTabs,
        text: 'Initial Reach Out',
        isFollowup: false
      },
      {
        ...repeatedValueForTabs,
        text: 'First Follow Up',
        isFollowup: true
      },
      {
        ...repeatedValueForTabs,
        text: 'Second Follow Up',
        isFollowup: true
      },
      {
        ...repeatedValueForTabs,
        text: 'Third Follow Up',
        isFollowup: true
      }
    ]
  }
}

export const getSupervisorFromId = async () => {
  const {
    currentPosition: { supervisorId }
  } = JSON.parse(localStorage.getItem('ngStorage-user'))
  if (supervisorId) {
    // This has it's own try catch, because the lack of supervisor shouldn't stop email from being sent out
    try {
      const { data: supervisor } = await getSupervisor(supervisorId)
      if (supervisor) {
        return supervisor
      }
    } catch (error) {
      console.error(error)
      return null
    }
  }
  return null
}

export const emailStages = [
  {
    validators: [validators.email],
    component: EmailStrip,
    full: false
  },
  {
    validators: [],
    component: AutomatedEmailFollowupCheckbox,
    full: false
  },
  {
    validators: [],
    component: SendEmailDialog,
    full: false
  },
  {
    validators: [],
    component: StatusPage,
    full: false
  }
]

export const email = {
  name: 'email',
  title: 'Send email',
  component: EmailActionComponent,
  stages: emailStages,
  loadStage: 3,
  finishAction: SendEmails
}

/**
 *
 * @param { ReturnType<getInitialState> } state
 */
async function SendEmails(dispatch, { listId, items }, state) {
  try {
    const templateType = getTemplateType(state)
    // If it's not automated followup, use the current template and send
    if (!state.isAutomatedFollowup) {
      const { template, previewTabs } = state

      const from = previewTabs[0].from || null

      const massActionObject = {
        listId,
        type: 'email',
        data: {
          body: prepTemplateForSending(template, from),
          additionalReplacements: state.additionalReplacements,
          templateType
        },
        actions: items.map(item => {
          const obj = {
            subject: state.previewTabs[state.selectedTabIndex].subject,
            listItemId: item.id,
            to: state.to[item.id].map(e => e.email).filter(i => i),
            cc: state.cc.map(e => e.email),
            bcc: state.bcc.map(e => e.email)
          }
          return obj
        })
      }

      if (from) {
        massActionObject.from = from.email
      }

      await massProcessingApi.createMassAction(massActionObject).then(massAction => {
        dispatch({
          type: actions.CREATE_MASS_ACTION_DONE,
          payload: massAction.id
        })
      })

      dispatch({
        type: actions.FEEDBACK,
        payload: 'Emails have been queued up for processing'
      })

      dispatch({
        type: actions.NEXT_STAGE
      })
      return
    }

    const { previewTabs } = state

    const { staticData } = stores.staticData

    // Avoid executing getScheduledTime too many times, so placing it outside of previewTabs.map loops
    const experts = items.map(item => {
      const { address } = item.data
      let timezone = null
      if (address && address.timezoneId) {
        const { timezones } = staticData.names
        timezone = timezones[address.timezoneId]
      }

      return {
        ...item,
        scheduleSlots: getScheduledTime(
          timezone,
          state.automationFrequencyInMinutes,
          3 // Number of follow ups
        )
      }
    })

    // Generate a bunch of promises and use Promise.all
    // Each tab has a selectedTemplate, using that information to generate different massActions
    // Because one template can be sent to multiple experts, so multiple actions will be generated for one massAction
    const massActionPromises = previewTabs.map((tab, tabIndex) => {
      const subject = tab.subject
      const content = tab.selectedTemplate.content
      const cc = state.cc.map(e => e.email)
      const bcc = state.bcc.map(e => e.email)

      // Generate actions from each selected experts
      const actions = experts.map(expert => {
        // Base action
        const baseAction = {
          subject: subject,
          listItemId: expert.id,
          to: state.to[expert.id].map(e => e.email).filter(x => x),
          cc,
          bcc
        }

        if (tab.isFollowup) {
          // To avoid follow up email being send to expert at the same time
          const hourIndex = tabIndex - 1

          baseAction.scheduleTime = expert.scheduleSlots[hourIndex]
        }

        return baseAction
      })

      const massAction = {
        listId,
        type: 'email',
        actions: actions.map(a => ({
          ...a,
          followupIndex: tabIndex
        })),
        data: {
          body: prepTemplateForSending(content, tab.from),
          additionalReplacements: state.additionalReplacements,
          templateType
        }
      }

      // If from doesn't exist, backend default to the user's email
      if (tab.from) {
        massAction.from = tab.from.email
      }

      // The first mass action is queue up right away
      if (tab.isFollowup) {
        // isAutomatedFollowup is the flag that backend uses to determine if massAction should be queued or scheduled
        massAction.isAutomatedFollowup = true
        massAction.data.followupIndex = tabIndex
      }

      return massProcessingApi.createMassAction(massAction)
    })

    const results = await Promise.all(massActionPromises)
    dispatch({
      type: actions.CREATE_MULTIPLE_MASS_ACTION_DONE,
      payload: results
    })

    dispatch({
      type: actions.FEEDBACK,
      payload: 'Emails have been queued up for processing'
    })

    dispatch({
      type: actions.NEXT_STAGE
    })
  } catch (e) {
    console.error(e)
  }
}

export const convertLocalTemplateToDBSchema = (template, group_name) => {
  return {
    content: template.value,
    created_at: new Date(),
    updated_at: new Date(),
    group: group_name,
    groupDefault: null,
    id: template.key,
    name: template.key,
    placeholders: template.placeholders || '',
    subject: template.subject,
    isLocal: true,
    key: template.key
  }
}

function setSelectedTemplateType(templates) {
  return templates.map(template => {
    template.selectedTemplateType = getGlobalTemplateType()
    return template
  })
}

const getEmailTemplates = async templateGroupName => {
  try {
    const apiTemplates = await emailTemplateApi.getByGroup(templateGroupName)
    const templates = setSelectedTemplateType(apiTemplates)
    let initialEmailTemplate

    if (templates && templates[0]) {
      initialEmailTemplate = await emailTemplateApi.get(templates[0].id)
    }
    return {
      templates,
      initialEmailTemplate
    }
  } catch (e) {
    console.error(e)
    return null
  }
}

function getEmailTemplatesFromLocalStorage() {
  const oldLocalTemplates = localStorage.getItem('al_email_templates')
  return oldLocalTemplates
    ? JSON.parse(oldLocalTemplates)
    : []
}

// First Component to Load
function EmailActionComponent({ massAction, items, list }) {
  const initialEmailState = getInitialState()

  const [state, setState] = React.useState({
    ...initialEmailState
  })

  const initialLoad = async () => {
    setState({
      ...state,
      loading: true
    })
    // Get the template choices and set initial templates
    const {
      templates: inviteTemplates,
      initialEmailTemplate: defaultInviteTemplate
    } = await getEmailTemplates('al_initial_outreach')

    const {
      templates: followupTemplates,
      initialEmailTemplate: defaultFollowupTemplate
    } = await getEmailTemplates('al_followup')

    const oldLocalTemplates = getEmailTemplatesFromLocalStorage()

    // Local template currently don't make distinction between email groups, so passing in group name is only to make data consistent
    const formattedOldLocalTemplates = oldLocalTemplates.map(ot =>
      convertLocalTemplateToDBSchema(ot, 'al_initial_outreach')
    )

    const supervisor = await getSupervisorFromId()

    const newTabData = state.previewTabs.map((tab, index) => {
      if (tab.isFollowup) {
        const originalTab = {
          ...tab,
          selectedTemplate: defaultFollowupTemplate,
          // Concat both local storage templates with db templates
          templates: [...followupTemplates, ...formattedOldLocalTemplates],
          subject: defaultFollowupTemplate.subject
        }

        // If the tab is the last one, prefill supervisor email for "from" field
        if (state.previewTabs.length - 1 === index && supervisor) {
          const { currentPosition } = JSON.parse(
            localStorage.getItem('ngStorage-user')
          )
          // employeePositionId 1 is Associate
          if (currentPosition && currentPosition.employeePositionId === 1) {
            // Send as supervisor
            originalTab.from = supervisor
          }
        }

        return originalTab
      }
      return {
        ...tab,
        selectedTemplate: defaultInviteTemplate,
        templates: [...inviteTemplates, ...formattedOldLocalTemplates],
        subject: defaultFollowupTemplate.subject
      }
    })

    const to = {}
    for (const item of items.filter(i => i.formatted?.emails?.length)) {
      to[item.id] = item.formatted.emails.map(email => email.selected ? ({ email: email.email }): null).filter(i => i)
    }
    setState({
      ...state,
      previewTabs: newTabData,
      loading: false,
      supervisor,
      // The template to display and edit
      template: newTabData[state.selectedTabIndex].selectedTemplate.content,
      subject: newTabData[state.selectedTabIndex].selectedTemplate.subject,
      to
    })
  }
  // Get the email templates on initialization
  useEffect(() => {
    initialLoad()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items])

  const currentStage = email.stages[massAction.stage]

  // Load the component according to stage
  if (currentStage) {
    const { component: NestedComponent } = currentStage
    return (
      <NestedComponent
        items={items}
        list={list}
        state={state}
        setState={setState}
        action={email}
      />
    )
  }
  // If massAction's stage is out of range of the stage array, dont render anything
  return null
}

const InvalidExperts = () => {
  return (
    <p
      style={{
        fontSize: '14px',
        margin: '0 10px 0 0',
        fontFamily: 'Roboto',
        color: '#f44336'
      }}
    >
      There are experts who have invalid emails. They will be removed
    </p>
  )
}

const ValidExperts = () => {
  return (
    <p
      style={{
        fontSize: '14px',
        margin: '0 10px 0 0',
        fontFamily: 'Roboto',
        color: '#357a38'
      }}
    >
      All experts can be used
    </p>
  )
}

// The checkbox for user to confirm if they want to have automated email followup or not
// Default to false (not sending automated followups)
function AutomatedEmailFollowupCheckbox({ state, setState }) {
  const dispatch = React.useContext(ListViewDispatchContext)
  // Rerender to avoid hooks mismatch
  useEffect(() => { }, [])

  const onNext = () => {
    // Validate frequency is it's automated followup

    if (state.isAutomatedFollowup) {
      // It's not valid when it's not a number or it's less than 15
      if (
        isNaN(state.automationFrequencyInMinutes) ||
        state.automationFrequencyInMinutes < 15
      ) {
        setState({
          ...state,
          minuteError: true
        })
        return
      }
    }

    dispatch({
      type: actions.NEXT_STAGE
    })
  }

  if (state.loading) {
    return (
      <CircularProgress
        style={{
          color: '#429bdc',
          width: '25px',
          height: '25px'
        }}
      />
    )
  }

  return (
    <div className="mp-flex-row">
      <FollowupOptions state={state} setState={setState} />
      <Button onClick={onNext}>Next</Button>
      <Button
        onClick={() => {
          dispatch({
            type: actions.END_ACTION
          })
        }}
      >
        Cancel
      </Button>
    </div>
  )
}

function EmailStrip() {
  const state = React.useContext(ListViewStateContext)
  const dispatch = React.useContext(ListViewDispatchContext)
  const invalidItems = [
    ...state.items.filter(item => {
      const baseCheck =
        item.data.checked &&
        (!validate(item, email.stages[0].validators)?.isValid || !item?.formatted?.emails.filter(x => x.selected).length)
      if (state.filterValid === 'VALID') {
        return state.massAction.name === 'email'
          ? !item.data.sherlock?.consultation?.allowed || baseCheck
          : !item.data.sherlock?.survey?.allowed || baseCheck
      } else {
        return baseCheck
      }
    })
  ]

  useEffect(() => {
    if (!invalidItems.length) {
      dispatch({
        type: actions.NEXT_STAGE,
        payload: { uncheck: [] }
      })
    }
  }, [dispatch, invalidItems.length])

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center'
      }}
    >
      {!!invalidItems.length && state.filterValid !== 'VALID' ? (
        <InvalidExperts state={state} dispatch={dispatch} />
      ) : (
        <ValidExperts />
      )}
      <span
        className={`${invalidItems.length ===
          state.items.filter(i => !!i.data.checked).length
          ? 'al-text-button-disabled'
          : 'al-text-button'
          }`}
        style={{ margin: '0 10px 0 0' }}
        onClick={() => {
          if (
            invalidItems.length ===
            state.items.filter(i => !!i.data.checked).length
          ) {
            return
          }
          dispatch({
            type: actions.NEXT_STAGE,
            payload: {
              uncheck: invalidItems.filter(i => i.data.checked).map(i => i.id)
            }
          })
        }}
      >
        {!!invalidItems.length && state.filterValid !== 'VALID'
          ? 'Remove & Send'
          : 'Send'}
      </span>
      <span
        className={`al-text-button`}
        onClick={() => {
          dispatch({
            type: actions.END_ACTION
          })
        }}
      >
        Cancel
      </span>
    </div>
  )
}

function StatusPage() {
  useEffect(() => { }, [])
  const MPState = React.useContext(ListViewStateContext)
  const dispatch = React.useContext(ListViewDispatchContext)

  return (
    <div style={{ marginLeft: '10px' }}>
      Emails are being processed
      <Button
        onClick={() => {
          dispatch({ type: actions.END_ACTION })
          if (MPState.massActions[0]) {
            // If there are multipls mass actions, stop all of them
            MPState.massActions.forEach(ma => {
              massProcessingApi.stopMassAction(ma.id)
            })

            return
          }
          massProcessingApi.stopMassAction(MPState.massAction.id)
        }}
      >
        Stop
      </Button>
    </div>
  )
}

const getMaxEmailToCount = ({ to }, id) => {
  if (id) {
    to[id] = to[id]
      .map(e => {
        if (e.email?.email) return e.email.selected ? e.email : undefined
        return e
      })
      .filter(e => e)
  }
  return _.reduce(
    to,
    (max, emails) => (emails?.length > max ? emails.length : max),
    0
  )
}

/**
 * Render send email dialog
 *
 * @param {{ items: any[]; state: ReturnType<getInitialState>; setState: import('react').Dispatch<ReturnType<getInitialState>>; list: any}} param0
 */
export function SendEmailDialog({ items, state, setState, list }) {
  const MPState = React.useContext(ListViewStateContext)
  const dispatch = React.useContext(ListViewDispatchContext)

  // Employee used for autocomplete lookup
  const {
    employeeStore: { employees }
  } = stores

  const currentTab = state.previewTabs[state.selectedTabIndex]

  const preview = refillTemplate(
    state.template,
    items[state.currentItem],
    state,
    currentTab.from
  )

  useEffect(() => { }, [])

  const formatCcBcc = async value => {
    const oldValues = value.filter(v => !v.id)
    const newValue = value.find(v => !!v.id)

    if (!!newValue) {
      const employeeData = await getAdditionalEmployee(newValue.id)
      const returnValue = [
        ...oldValues,
        { name: employeeData.data.fullName, email: employeeData.data.email }
      ]

      return returnValue
    }

    const isFree = value.find(v => typeof v === 'string')

    return !!isFree
      ? [
        ...value.filter(v => typeof v !== 'string'),
        { name: isFree, email: isFree }
      ]
      : value
  }

  const handleFrom = value => {
    const clonedTabs = state.previewTabs.slice(0)

    clonedTabs[state.selectedTabIndex].from = toJS(value)

    setState({
      ...state,
      previewTabs: clonedTabs
    })
  }

  const handleTo = ({ state, setState, currentItem, value }) => {
    if (state.showTemplate) {
      const currentEmailCount = getMaxEmailToCount(state)
      if (currentEmailCount === 1) return // Can't remove last email

      const to = state.to
      for (const id in to) {
        to[id] =
          to[id].length >= currentEmailCount ? to[id].slice(0, -1) : to[id]
      }

      setState({ ...state, to })
    }

    if (!state.showTemplate) {
      const isFree = value.find(v => typeof v === 'string')

      const result = Boolean(isFree)
        ? [...value.filter(v => typeof v !== 'string'), { email: isFree }]
        : value

      setState({
        ...state,
        to: {
          ...state.to,
          [currentItem.id]: result
        }
      })

      return result
    }
  }

  const handleCc = async (_e, value) => {
    const formattedCbBcc = await formatCcBcc(value)

    setState({
      ...state,
      templates: [],
      cc: formattedCbBcc
    })
  }

  const handleBcc = async (_event, value) => {
    const formattedCbBcc = await formatCcBcc(value)
    setState({
      ...state,
      templates: [],
      bcc: formattedCbBcc
    })
  }

  const filter = createFilterOptions()

  const onTemplateTypeChange = async (newValue, currentTemplate) => {
    if (!newValue) return

    if (_.get(currentTemplate, 'isLocal')) {
      const oldLocalTemplates = getEmailTemplatesFromLocalStorage()
      const findLocalTemplate = oldLocalTemplates.map(template => {
        if (template.key === currentTemplate.key) {
          template.selectedTemplateType = newValue
        }
        return template
      })

      localStorage.setItem(
        'al_email_templates',
        JSON.stringify(findLocalTemplate)
      )
    }

    localStorage.setItem("templateType", JSON.stringify(newValue))

    setState({ ...state, selectedTemplateType: newValue })
  }

  const onTemplateChange = async (_event, newValue) => {
    if (!newValue) return
    // Get new template
    const { id, name, isLocal } = newValue

    // Clone the array
    const newPreviewTabs = state.previewTabs.slice(0)

    // Create new local template and update previewTabs, subject and template
    if (isLocal) {
      const oldLocalTemplates = getEmailTemplatesFromLocalStorage()

      // Get the selectTemplate index
      const selectedTemplateIndex = newPreviewTabs[
        state.selectedTabIndex
      ].templates.findIndex(template => template.id === id)

      // Existing template
      if (selectedTemplateIndex >= 0) {
        // If template already exist, use the one in the state
        newPreviewTabs[state.selectedTabIndex].selectedTemplateIndex =
          selectedTemplateIndex
        const template =
          newPreviewTabs[state.selectedTabIndex].templates[
          selectedTemplateIndex
          ]
        const findLocalTemplate = oldLocalTemplates.find(template => template.key === newValue.key)
        template.selectedTemplateType = findLocalTemplate.selectedTemplateType
        newPreviewTabs[state.selectedTabIndex].selectedTemplate = template
        newPreviewTabs[state.selectedTabIndex].subject = template.subject
        setState({
          ...state,
          previewTabs: newPreviewTabs,
          subject: template.subject,
          template: template.content
        })
        return
      }

      // New Template
      const newTemplate = {
        key: name,
        subject: `Choose a subject for "${newValue.name}"`,
        value: state.template,
        cc: [],
        bcc: [],
        type: MPState.massAction.name,
        selectedTemplateType: state.selectedTemplateType
      }

      const currentGroup = state.previewTabs[state.selectedTabIndex].isFollowup
        ? 'al_followup'
        : 'al_initial_outreach'

      const dbSchemaTemplate = convertLocalTemplateToDBSchema(
        newTemplate,
        currentGroup
      )

      const newTemplateLength =
        newPreviewTabs[state.selectedTabIndex].templates.push(dbSchemaTemplate)

      newPreviewTabs[state.selectedTabIndex].selectedTemplate = dbSchemaTemplate
      const newSelectedTemplateIndex = newTemplateLength - 1
      newPreviewTabs[state.selectedTabIndex].selectedTemplateIndex =
        newSelectedTemplateIndex
      newPreviewTabs[state.selectedTabIndex].templates[
        newSelectedTemplateIndex
      ].selectedTemplateType = state.selectedTemplateType

      localStorage.setItem(
        'al_email_templates',
        JSON.stringify([...oldLocalTemplates, newTemplate])
      )

      setState({
        ...state,
        previewTabs: newPreviewTabs,
        subject: newTemplate.subject,
        template: dbSchemaTemplate.content
      })
      return
    }

    if (id) {
      // Should we store the full template and the user change and check if it already exist when user change template?

      // Get the selectTemplate index
      const selectedTemplateIndex = newPreviewTabs[
        state.selectedTabIndex
      ].templates.findIndex(template => template.id === id)
      // Get template from db
      const template = await emailTemplateApi.get(id)
      newPreviewTabs[state.selectedTabIndex].selectedTemplate = template
      newPreviewTabs[state.selectedTabIndex].selectedTemplateIndex =
        selectedTemplateIndex

      setState({
        ...state,
        previewTabs: newPreviewTabs,
        // Set the current display template
        template: template.content,
        subject: template.subject
      })
    }
  }

  const onTabChange = index => {
    // Use the current index to get the current tab and its info
    const displayTemplate = state.previewTabs[index].selectedTemplate

    setState({
      ...state,
      selectedTabIndex: index,
      template: displayTemplate.content,
      subject: displayTemplate.subject
    })
  }

  const onRichTextEditorChange = text => {
    // Store text change as content in the template of previewTabs

    const cloneTabs = state.previewTabs.slice(0)

    cloneTabs[state.selectedTabIndex].selectedTemplate = {
      ...cloneTabs[state.selectedTabIndex].selectedTemplate,
      content: text
    }

    setState({ ...state, template: text, previewTabs: cloneTabs })
  }

  const updateTemplate = async (key, newTemplate) => {
    const oldLocalTemplates = getEmailTemplatesFromLocalStorage()

    const newTemplates = oldLocalTemplates.map(ot => {
      if (ot.key === key) {
        return newTemplate
      }
      return ot
    })

    localStorage.setItem('al_email_templates', JSON.stringify(newTemplates))
  }

  const onSendEmail = async () => {
    if(state.template.indexOf('[topic of interest]') !== -1) {
      showDialog({
        title: `Unfilled placeholder`,
        text: `You have an unfilled placeholder [topic of interest] in the email template, please fill it in before proceeding further.`,
        type: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Ok'
      })
      return
    }
    if(state.template.indexOf('[Briefly explaining what the scope of the project is to help filter out experts who may not be the best fit]') !== -1) {
      showDialog({
        title: `Unfilled placeholder`,
        text: `You have an unfilled placeholder [Briefly explaining what the scope of the project is ...] in the email template, please fill it in before proceeding further.`,
        type: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Ok'
      })
      return
    }
    setState({
      ...state,
      sendingEmails: true,
      loading: true
    })

    await state.finishAction(
      dispatch,
      {
        items,
        listId: list ? list.id : items[0].listId
      },
      state
    )
    setState({
      ...state,
      sendingEmails: false,
      loading: false
    })
  }

  // Get object of params from items(experts)
  /* Should look like
  {
    {id: 'id'}
  }
  */
  const replacementsFromData = _(items)
    .map(i => Object.keys(flat(i.data)))
    .flattenDeep()
    .uniq()
    .value()
    .reduce((accum, value) => {
      return {
        ...accum,
        [value]: value
      }
    }, {})

  const defaultTemplate = {
    id: 0,
    name: 'Default Template',
    groupDefault: null
  }

  const currentTemplate =
    currentTab.templates[currentTab.selectedTemplateIndex] || defaultTemplate

  const findTemplateSelectedType = getEmailTemplatesFromLocalStorage().find(
    template => template.key === currentTemplate.key
  )

  const selectedTemplateType =
    _.get(findTemplateSelectedType, 'selectedTemplateType') || state.selectedTemplateType

  const getEmailToValue = () => {
    if (state.showTemplate) {
      return _.range(getMaxEmailToCount(state, items[state.currentItem].id)).map(() => ({ email: 'Email' }))
    }
    const currentItemId = items[state.currentItem].id
    return state.to[currentItemId].map(e => {
      if (e.email?.email) return e.email.selected ? e.email : undefined
      return e
    }).filter(e=> e)
  }

  const employeeForLookup = employees.$mobx.values.filter(
    employee => employee.active
  )

  return (
    <Dialog fullWidth={true} maxWidth={'sm'} open={true}>
      {state.loading ? <LinearProgress /> : null}
      <DialogTitle>Send Email</DialogTitle>
      <DialogContent>
        {/* begin email composition view */}
        <CustomScrollBars
          universal
          hideTracksWhenNotNeeded
          renderTrackHorizontal={props => (
            <div {...props} style={{ display: 'none' }} />
          )}
          style={{ height: 560 }}>
          <section className="ms-email-section">
            {state.isAutomatedFollowup && (
              <>
                <div
                  className="ms-email-template-actions"
                  style={{ marginBottom: '30px' }}>
                  {state.previewTabs.map((tab, index) => {
                    return (
                      <div
                        key={index}
                        className={`ms-email-template-tab-selection ${state.selectedTabIndex === index ? 'active' : ''
                          }`}
                        onClick={() => {
                          onTabChange(index)
                        }}>
                        {tab.text}
                      </div>
                    )
                  })}
                </div>
              </>
            )}
            <div className="ms-email-template-actions">
              {currentTab && (
                <>
                  <Autocomplete
                    size="small"
                    onChange={onTemplateChange}
                    value={currentTemplate}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    options={currentTab.templates}
                    getOptionLabel={option => option.name}
                    renderOption={option => {
                      if (option.isLocal) {
                        return option.key
                      }
                      return option.name
                    }}
                    style={{ width: 230 }}
                    freeSolo
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params)
                      if (params.inputValue !== '') {
                        filtered.push({
                          isLocal: true,
                          id: null,
                          groupDefault: null,
                          name: params.inputValue,
                          key: `Create "${params.inputValue}"`
                        })
                      }
                      return filtered
                    }}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Tooltip key={index} tooltip={option.name}>
                          <Chip
                            color="primary"
                            key={index}
                            label={option.name}
                            style={{
                              height: '24px',
                              backgroundColor: '#429ADC'
                            }}
                            {...getTagProps({ index })}
                          />
                        </Tooltip>
                      ))
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Template"
                        variant="standard"
                      />
                    )}
                  />
                </>
              )}

              <div className="ms-email-template-actions-switch">
                <div
                  onClick={() =>
                    setState({ ...state, showTemplate: !state.showTemplate })
                  }>
                  <Switch color="primary" checked={!state.showTemplate} />
                  {!state.showTemplate ? 'Preview' : 'Template'}
                </div>
                {!state.showTemplate && (
                  <>
                    <NavigateBeforeIcon
                      onClick={() =>
                        changeItem({ state, setState, items, change: -1 })
                      }
                    />
                    {state.currentItem + 1}/{items.length}
                    <NavigateNextIcon
                      onClick={() =>
                        changeItem({ state, setState, items, change: 1 })
                      }
                    />
                  </>
                )}
              </div>
            </div>

            <div className="ms-email-template-actions">
              {currentTab && (
                <>
                  <Autocomplete
                    size="small"
                    onChange={(e, value) =>
                      onTemplateTypeChange(value, currentTemplate)
                    }
                    value={selectedTemplateType}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    options={currentTab.templateTypes}
                    getOptionLabel={option => option.name}
                    renderOption={option => {
                      if (option.isLocal) {
                        return option.key
                      }
                      return option.name
                    }}
                    style={{ width: 230 }}
                    freeSolo
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params)
                      if (params.inputValue !== '') {
                        filtered.push({
                          isLocal: true,
                          id: null,
                          groupDefault: null,
                          name: params.inputValue,
                          key: `Create "${params.inputValue}"`
                        })
                      }
                      return filtered
                    }}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Tooltip key={index} tooltip={option.name}>
                          <Chip
                            color="primary"
                            key={index}
                            label={option.name}
                            style={{
                              height: '24px',
                              backgroundColor: '#429ADC'
                            }}
                            {...getTagProps({ index })}
                          />
                        </Tooltip>
                      ))
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Template Type"
                        variant="standard"
                      />
                    )}
                  />
                </>
              )}
            </div>

            <div className="ms-email-template-bod-container">
              <div className="ms-email-template-subject-container">
                <Accordion
                  style={{
                    boxShadow: 'none',
                    padding: 0
                  }}>
                  <AccordionSummary
                    style={{
                      padding: 0
                    }}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header">
                    <FormControl fullWidth>
                      <Autocomplete
                        freeSolo
                        size="small"
                        value={currentTab.from}
                        options={
                          Array.isArray(employeeForLookup)
                            ? employeeForLookup
                            : []
                        }
                        getOptionLabel={option => {
                          if (option && typeof option.email === 'string') {
                            return option.email
                          }
                          return ''
                        }}
                        onChange={(e, value) => handleFrom(value)}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Tooltip key={index} tooltip={option.email}>
                              <Chip
                                color="primary"
                                key={index}
                                label={option.email}
                                style={{
                                  height: '24px',
                                  backgroundColor: '#429ADC'
                                }}
                                {...getTagProps({ index })}
                              />
                            </Tooltip>
                          ))
                        }
                        renderInput={params => (
                          <TextField
                            {...params}
                            id="standard-basic"
                            variant="standard"
                            label="From:"
                          />
                        )}
                      />
                    </FormControl>
                  </AccordionSummary>
                  <AccordionDetails
                    style={{
                      display: 'block',
                      padding: '0'
                    }}>
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        freeSolo
                        size="small"
                        value={getEmailToValue()}
                        options={[]}
                        getOptionLabel={option => option.email}
                        onChange={(e, value) =>
                          handleTo({
                            state,
                            dispatch,
                            setState,
                            currentItem: items[state.currentItem],
                            value
                          })
                        }
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Tooltip key={index} tooltip={option.email}>
                              <Chip
                                color="primary"
                                key={index}
                                label={option.email}
                                style={{
                                  height: '24px',
                                  backgroundColor: '#429ADC'
                                }}
                                {...getTagProps({ index })}
                              />
                            </Tooltip>
                          ))
                        }
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="To:"
                          />
                        )}
                      />
                    </FormControl>

                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        freeSolo
                        size="small"
                        value={state.cc}
                        options={MPState.allEmployees}
                        getOptionLabel={option => option.name}
                        onChange={handleCc}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Tooltip key={index} tooltip={option.name}>
                              <Chip
                                color="primary"
                                key={index}
                                label={option.name}
                                style={{
                                  height: '24px',
                                  backgroundColor: '#429ADC'
                                }}
                                {...getTagProps({ index })}
                              />
                            </Tooltip>
                          ))
                        }
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Cc:"
                            placeholder="Cc"
                          />
                        )}
                      />
                    </FormControl>

                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        freeSolo
                        value={state.bcc}
                        size="small"
                        options={MPState.allEmployees}
                        getOptionLabel={option => option.name}
                        onChange={handleBcc}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Tooltip key={index} tooltip={option.name}>
                              <Chip
                                color="primary"
                                key={index}
                                label={option.name}
                                style={{
                                  height: '24px',
                                  backgroundColor: '#429ADC'
                                }}
                                {...getTagProps({ index })}
                              />
                            </Tooltip>
                          ))
                        }
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Bcc:"
                            placeholder="Bcc"
                          />
                        )}
                      />
                    </FormControl>
                  </AccordionDetails>
                </Accordion>

                <FormControl fullWidth>
                  <TextField
                    size="small"
                    fullWidth
                    value={state.previewTabs[state.selectedTabIndex].subject}
                    label="Subject:"
                    onChange={e =>
                      handleEmailSubjectChange({
                        state,
                        setState,
                        value: e.target.value
                      })
                    }
                  />
                </FormControl>
              </div>
              <div style={{ padding: '0 16px' }}>
                {state.showTemplate ? (
                  <RichTextEditor
                    large
                    skipWrapper
                    value={state.template}
                    onChange={onRichTextEditorChange}
                    replacements={{
                      ...state.additionalReplacements,
                      ...replacementsFromData
                    }}
                  />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: preview }} />
                )}
              </div>
            </div>
          </section>
        </CustomScrollBars>
        {/* end of editor view */}

        <p
          style={{
            display: 'flex',
            alignItems: 'center',
            color: '#777',
            margin: '5px 0 0 0'
          }}>
          <InfoOutlinedIcon /> use # to add variables
        </p>

        <div className="mp-send-email-action-button-container">
          {/* TODO: Add some user feedback when save is complete */}
          {state.previewTabs[state.selectedTabIndex].selectedTemplate
            .isLocal ? (
            <Button
              className={`mp-send-email-action-button-cancel`}
              style={{ marginTop: '10px' }}
              onClick={() => {
                const selectedTemplate =
                  state.previewTabs[state.selectedTabIndex].selectedTemplate
                  updateTemplate(selectedTemplate.key, {
                  key: selectedTemplate.name,
                  subject: selectedTemplate.subject,
                  value: state.template,
                  cc: state.cc,
                  bcc: state.bcc,
                  type: MPState.massAction.name,
                  selectedTemplateType: state.selectedTemplateType
                })
              }}>
              Save
            </Button>
          ) : (
            <div>&nbsp;</div>
          )}
          <div>
            <Button
              className={`mp-send-email-action-button-cancel mp-send-email-action-button`}
              onClick={() => {
                dispatch({ type: actions.END_ACTION })
              }}>
              Cancel
            </Button>
            <Button
              className="mp-send-email-action-button-next mp-send-email-action-button"
              style={{
                backgroundColor: `${state.sendingEmails ? '#429bdc ' : '#195f93'
                  }`
              }}
              disabled={shouldEmailsBeDisabled(state)}
              onClick={onSendEmail}>
              {state.sendingEmails ? (
                <CircularProgress
                  style={{
                    color: '#fff',
                    width: '25px',
                    height: '25px'
                  }}
                />
              ) : (
                'Send'
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

const shouldEmailsBeDisabled = state => {
  return (
    state.sendingEmails ||
    state.loading ||
    _.find(state.to, emails => !emails.length)
  )
}

function changeItem({ state, setState, items, change }) {
  const currentItem = state.currentItem + change
  if (currentItem < 0 || currentItem >= items.length) return

  setState({
    ...state,
    currentItem
  })
}
/**
 * Change email subject for initial outreach and other followups
 *
 * @param {{ state: ReturnType<getInitialState>; setState: import('react').Dispatch<ReturnType<getInitialState>>; value: string }}
 */
function handleEmailSubjectChange({ state, setState, value }) {
  const cloneTabs = state.previewTabs.slice(0)

  cloneTabs[state.selectedTabIndex].selectedTemplate.subject = value
  cloneTabs[state.selectedTabIndex].subject = value

  setState({ ...state, previewTabs: cloneTabs })
}

export function prepTemplateForSending(tpl, from) {
  // tpl is the template
  /// item is the current expert
  // additionalReplacements
  if (!tpl) return ''
  const templateHighlightRemoved = tpl
    .replaceAll('style="color: blue"', '')
    .replaceAll('style="color: blue;"', '')
    .replaceAll('style="color:blue"', '')
    .replaceAll('style="color:blue;"', '')

  const re = /data-replacement="(.*?)"/g
  const replacements = [...templateHighlightRemoved.matchAll(re)].map(i => ({
    match: i[0],
    key: i[1]
  }))

  const div = document.createElement('div')
  div.innerHTML = templateHighlightRemoved

  const keysToChangeForFrom = {
    userName: from?.label || from?.fullName,
    userEmail: from?.email,
    userPosition: from?.position || from?.currentPosition?.positionDescription
  }

  for (const { key } of replacements) {
    const el = div.querySelectorAll(`span[data-replacement="${key}"]`)
    for (const e of el) {
      if (from && keysToChangeForFrom[key]) {
        e.innerHTML = keysToChangeForFrom[key]
        continue
      }

      e.innerHTML = `{{${key}}}`
    }
  }

  return div.innerHTML
    .replace('{{surveyLink}}', '{{{surveyLink}}}')
    .replace(/{{officeAddress}}/g, '{{{officeAddress}}}')
}

export function refillTemplate(tpl, item, state, from) {
  // tpl is the template
  /// item is the current expert
  // additionalReplacements
  if (!tpl) return ''
  const templateHighlightRemoved = tpl
    .replaceAll('style="color: blue"', '')
    .replaceAll('style="color: blue;"', '')
    .replaceAll('style="color:blue"', '')
    .replaceAll('style="color:blue;"', '')

  const repl = {
    ...flat(item?.data || {}),
    ...state.additionalReplacements,
    ...(state.additionalItemData?.(item, state) || {})
  }

  if (!repl.fullName) {
    // Put together a full name if it doesn't exist
    repl.fullName = `${repl.firstName || ''} ${repl.lastName || ''}`
  }

  const re = /data-replacement="(.*?)"/g
  const replacements = [...templateHighlightRemoved.matchAll(re)].map(i => ({
    match: i[0],
    key: i[1]
  }))

  const div = document.createElement('div')
  div.innerHTML = templateHighlightRemoved

  const keysToChangeForFrom = {
    userName: from?.label || from?.fullName,
    userEmail: from?.email,
    userPosition: from?.position || from?.currentPosition?.positionDescription
  }

  for (const { key } of replacements) {
    const el = div.querySelectorAll(`span[data-replacement="${key}"]`)
    for (const e of el) {
      if (from && keysToChangeForFrom[key]) {
        e.innerHTML = keysToChangeForFrom[key]
        continue
      }

      if (typeof repl[key] === 'string') {
        e.innerHTML = repl[key]
      } else {
        e.innerHTML = JSON.stringify(repl[key])
      }
    }
  }

  return div.innerHTML
}

const FollowupOptions = ({ state, setState }) => {
  const onFrequencyChange = e => {
    setState({
      ...state,
      automationFrequencyInMinutes: e.target.value,
      minuteError: false
    })
  }

  return (
    <Box className="mp-flex-row">
      <TooltipMUI title="Follow ups will automatically be sent to experts during the Golden hours. After the first outreach, the follow up will be sent based on the minutes set">
        <FormControlLabel
          label={
            'Send automatic follow-ups' +
            (state.isAutomatedFollowup ? ' every' : '')
          }
          control={
            <Checkbox
              onChange={() => {
                setState({
                  ...state,
                  isAutomatedFollowup: !state.isAutomatedFollowup
                })
              }}
              checked={state.isAutomatedFollowup}
            />
          }
        />
      </TooltipMUI>
      {state.isAutomatedFollowup && (
        <Box className="mp-flex-row">
          <TooltipMUI title="The minimum time is 15 minutes">
            <TextField
              type="number"
              error={state.automationFrequencyInMinutes < 15}
              style={{ width: 45, marginRight: 12 }}
              min={15}
              value={state.automationFrequencyInMinutes}
              onChange={onFrequencyChange}
            />
          </TooltipMUI>
          <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
            minutes.
          </span>
        </Box>
      )}
    </Box>
  )
}
